import React, { useState, useEffect } from 'react'
import { Button } from 'primereact/button'
import { fnGetForm, fnGetFormHeader, fnGetLayout } from '../../util/CSLayoutUtil'
import CSUtil from '../../util/CSUtil'
import CSConfigUtil from '../../util/CSConfigUtil';
import { fnGetFormMetaData } from '../../util/CSMiscUtil';

const mCSUtil = CSUtil.cfGetInstance();

const CSCOHomeLayout = (gProps) => {
    const [mSelectedFeature, setSelectedFeature] = useState(null);
    const [mHeading, setHeading] = useState('');
    const [mSidebarActions, setSidebarActions] = useState(null);

    const processClick = (lChild) => {
        setSelectedFeature(null);
        if(lChild){
            setHeading(lChild.title_);

            let lMetaData = {}
            lMetaData.app_code_            = CSConfigUtil.mAppCode;
            lMetaData.app_id_              = lChild.layout_item_code_;
            lMetaData.feature_ref_id_      = lChild.layout_item_ref_id_;
            lMetaData.layout_code_         = lChild.layout_code_;
            lMetaData.layout_item_ref_id_  = lChild.layout_item_ref_id_;
            lMetaData.user_id_             = CSConfigUtil.mUserId;
            lMetaData.pFormType            = mCSUtil.mLayoutCodeTypeMap[lMetaData.layout_code_];
            if(!lMetaData.pFormType) {lMetaData.pFormType = lChild.layout_code_;}
        
            fnGetFormMetaData(lMetaData, (lResponseData)=>{
                if(lResponseData) {
                    lMetaData.mFormCriteria           = lResponseData.pFormCriteria;
                    lMetaData.pFormCriteria           = lResponseData.pFormCriteria;
                    lMetaData.mFormServices           = lResponseData.pServices;
                    lMetaData.pServices               = lResponseData.pServices;
                    lMetaData.mFormActions            = lResponseData.pFormActions;
                    lMetaData.pFormActions            = lResponseData.pFormActions;
                    lMetaData.mFormItems              = lResponseData.pFormItems;
                    lMetaData.pFormItems              = lResponseData.pFormItems;
                    lMetaData.pFormItems              = lResponseData.pFormItems;
                    lMetaData.mFormDetails            = lResponseData.pFormDetails;
                    lMetaData.pFormDetails            = lResponseData.pFormDetails;
                    lMetaData.mFormGrid               = lResponseData.pFormGrid;
                    lMetaData.pFormGrid               = lResponseData.pFormGrid;
                    lMetaData.mFormProperties         = lResponseData.pFormProperties;
                    lMetaData.pFormProperties         = lResponseData.pFormProperties;
                    lMetaData.mFormValidation         = lResponseData.pFormValidation;
                    lMetaData.pFormValidation         = lResponseData.pFormValidation;
                    lMetaData.mFormSelection          = lResponseData.pFormSelection;
                    lMetaData.pFormSelection          = lResponseData.pFormSelection;
                    lMetaData.mFormActionProperties   = lResponseData.pFormActionProperties;
                    lMetaData.pFormActionProperties   = lResponseData.pFormActionProperties;
                    lMetaData.mFormcriteriaProperties = lResponseData.pFormCriteriaProperties;
                    lMetaData.pFormCriteriaProperties = lResponseData.pFormCriteriaProperties;
                    lMetaData.mFormGridProperties     = lResponseData.pFormGridProperties;
                    lMetaData.pFormGridProperties     = lResponseData.pFormGridProperties;
                    lMetaData.mFormGridItemProperties = lResponseData.pFormGridItemProperties;
                    lMetaData.pFormGridItemProperties = lResponseData.pFormGridItemProperties;
                    lMetaData.mFormItemProperties     = lResponseData.pFormItemProperties;
                    lMetaData.pFormItemProperties     = lResponseData.pFormItemProperties;
                    lMetaData.mFormItemComputation    = lResponseData.pFormItemComputation;
                    lMetaData.pFormItemComputation    = lResponseData.pFormItemComputation;
                    lMetaData.mFormMetaData           = lResponseData;
                }

                if(lMetaData.pFormType === 'FORM') {
                    let lFeature = fnGetLayout(lMetaData.layout_code_, lMetaData);
                    setSelectedFeature(lFeature);
                }
                else {
                    let lFeature = fnGetForm(lMetaData);
                    setSelectedFeature(lFeature);
                }
            });
        }
    };

    useEffect(()=>
        {
            if(gProps.pFeatureRefId) {
                let lChildren = mCSUtil.mParentChildrenMap[gProps.pFeatureRefId];
                let lSidebarActions = [];
                if(lChildren) {
                    for(let lInd = 0; lInd < lChildren.length; lInd++){
                        let lChild = lChildren[lInd];
                        let lIconName = CSUtil.mLayoutMapIdIconMap[lChild.layout_map_ref_id_]
                        let lAction = 
                            <Button 
                                id             = { lChild.layout_map_ref_id_ } 
                                icon           = { lIconName } 
                                onClick={() => {
                                        processClick(lChild);
                                    }
                                }
                                tooltip        = { lChild.title_ }
                                tooltipOptions = {{ position: 'left' }}/>

                        lSidebarActions.push(lAction);
                        if(lInd === 0) {
                            processClick(lChild);               
                        }
                    }
                }

                setSidebarActions(lSidebarActions);
            }
        }, []
    );

    let lSidebar =
    <div >
        <div className='flex flex-column bg-primary border-round-sm justify-content-center align-items-center gap-3 h-full py-3 dashboard border-0 right-0' style={{ width: '3rem' }}>
            {mSidebarActions}
        </div>
    </div>

    return (
        <div className='overflow-hidden h-full'>
            { fnGetFormHeader(mHeading) }
            <div className=' flex justify-content-between align-items-top h-full'>
                <div className='flex-1 min-w-0  mx-2'>
                    { mSelectedFeature }
                </div>

                <div className='flex-none w-3rem flex flex-column justify-content-center align-items-center bg-primary border-round-lg' style={{ right: '0.2rem', margin: 'auto', height:'75%' }}>
                    { lSidebar }
                </div>
            </div>
        </div>
    )
}

export default CSCOHomeLayout;